import { render } from "./TaskCombineReportsMenuItem .vue?vue&type=template&id=2e959aee"
import script from "./TaskCombineReportsMenuItem .vue?vue&type=script&lang=js"
export * from "./TaskCombineReportsMenuItem .vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/TaskCombineReportsMenuItem .vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e959aee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e959aee', __exports__)) {
    console.log('reload')
    api.reload('2e959aee', __exports__)
  }
  
  module.hot.accept("./TaskCombineReportsMenuItem .vue?vue&type=template&id=2e959aee", () => {
    console.log('re-render')
    api.rerender('2e959aee', render)
  })

}


export default __exports__